var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Imac1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.5 5 C 6.0324991 5 4 7.0324991 4 9.5 L 4 30.5 C 4 32.967501 6.0324991 35 8.5 35 L 17.800781 35 L 17.175781 40 L 13.5 40 A 1.50015 1.50015 0 1 0 13.5 43 L 18.259766 43 A 1.50015 1.50015 0 0 0 18.740234 43 L 29.253906 43 A 1.50015 1.50015 0 0 0 29.742188 43 L 34.5 43 A 1.50015 1.50015 0 1 0 34.5 40 L 30.824219 40 L 30.199219 35 L 39.5 35 C 41.967501 35 44 32.967501 44 30.5 L 44 9.5 C 44 7.0324991 41.967501 5 39.5 5 L 8.5 5 z M 8.5 8 L 39.5 8 C 40.346499 8 41 8.6535009 41 9.5 L 41 30.5 C 41 31.346499 40.346499 32 39.5 32 L 28.746094 32 A 1.50015 1.50015 0 0 0 28.257812 32 L 19.740234 32 A 1.50015 1.50015 0 0 0 19.259766 32 L 8.5 32 C 7.6535009 32 7 31.346499 7 30.5 L 7 9.5 C 7 8.6535009 7.6535009 8 8.5 8 z M 24 27 A 1.5 1.5 0 0 0 24 30 A 1.5 1.5 0 0 0 24 27 z M 20.824219 35 L 27.175781 35 L 27.800781 40 L 20.199219 40 L 20.824219 35 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Imac1);
export default __webpack_public_path__ + "static/media/icons8-imac (1).bd96e75bf819224ba62073479f8db629.svg";
export { ForwardRef as ReactComponent };